<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span class="calibre4">Murder Under the Palms</span></p>
<p class="bk-title1"><span class="calibre4">A Charlotte Graham Mystery</span></p>
<p class="authorname"><span class="calibre4">Stefanie Matteson</span></p>
<p class="publisher"><span><img alt="image" class="calibre2" src="images/00005.jpeg"/></span></p>
<p class="publisher1"><span>MYSTERIOUSPRESS.COM</span></p>
<p class="publisher1"><span><img alt="image" class="calibre2" src="images/00006.jpeg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004.vue?270de550